import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'

interface ITransactionProps {
    data: IMoneyPoolTransaction | undefined
    isLoading: boolean
    isManager: boolean
    searchTrans: string
    setSearchtransaction: React.Dispatch<React.SetStateAction<string>>
    setSearchTrans: React.Dispatch<React.SetStateAction<string>>
}
export default function Transactions({
    data,
    isLoading,
    isManager,
    searchTrans,
    setSearchtransaction,
    setSearchTrans,
}: ITransactionProps) {
    if (isLoading || !data) {
        return <DotsLoading />
    }
    return (
        <div className="min-h-full bg-white pt-2 pb-4">
            {data.results.result.length === 0 ? (
                <p className="mt-2.5 text-center text-sm text-text-body">
                    تراکنشی وجود ندارد
                </p>
            ) : (
                data.results.result.map((item) => (
                    <Item item={item} key={item.id} isManager={isManager} />
                ))
            )}
        </div>
    )
}
